import { Badges, H5, P } from "../../../../AbstractElements";
import { AudioTesting, AutoText, MusicalTrendsAndPredictability } from "../../../../Constant";

const AutoTestingTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-location bg-info">
        <i className="icon-pulse" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="primary">{AudioTesting}</Badges>
        </div>
        <H5 className="m-0 vertical-timeline-element-subtitle">{MusicalTrendsAndPredictability}</H5>
        <P className="mb-0">{AutoText}</P>
        <audio controls preload="none">
          <source src="../assets/audio/horse.ogg" type="audio/ogg" />
        </audio>
        <span className="cd-date">June 12 2022</span>
      </div>
    </div>
  );
};
export default AutoTestingTimeline;
